export default{
  label:'border-radius',
  valueScope:[
    'rounded',
    'rounded-top',
    'rounded-right',
    'rounded-bottom',
    'rounded-left',
    'rounded-circle',
    'rounded-pill',
    'rounded-0',
    'rounded-sm',
    'rounded-lg',
  ],
}


// WEBPACK FOOTER //
// ./src/shell/schemas/general/border/radius.js